import "./styles/admin.scss";
import $ from "jquery";

( ( $ ) => {
	"use strict";
	$( () => {} );
	// Place your administration-specific JavaScript here
} )( jQuery );
